import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Testimonials.css';

const items = [
  {
    quote:
      'Global Sun delivered our 180 MW rooftop portfolio six weeks ahead of schedule. Two years in, fleet uptime is 99.4% and payback is tracking a full year faster than modeled.',
    name: 'Rajesh Kumar',
    role: 'Head of Sustainability, Delhi Industrial Group',
    initial: 'RK',
  },
  {
    quote:
      'Their Helios monitoring caught a string-level fault in a remote village microgrid before any user noticed a dip. That kind of proactive care is exactly why we renewed for another decade.',
    name: 'Anil Verma',
    role: 'CTO, Faridabad Rural Power Cooperative',
    initial: 'AV',
  },
  {
    quote:
      'The engineering discipline is world-class. Bifacial modules, tight tolerances, honest datasheets — and a warranty claim we made in year 3 was resolved in 48 hours.',
    name: 'Priya Sharma',
    role: 'EPC Director, UP Energy Solutions',
    initial: 'PS',
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((v) => (v + 1) % items.length), 6000);
    return () => clearInterval(id);
  }, []);
  const t = items[i];

  return (
    <section className="tests">
      <div className="container tests-inner">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="tests-head"
        >
          <span className="eyebrow">What clients say</span>
          <h2 className="section-title">
            Trusted by <span className="accent">Indian operators and DISCOMs</span>.
          </h2>
        </motion.div>

        <div className="tests-stage glass">
          <div className="quote-mark">“</div>
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
            >
              <p>{t.quote}</p>
              <footer>
                <div className="avatar">{t.initial}</div>
                <div>
                  <strong>{t.name}</strong>
                  <span>{t.role}</span>
                </div>
              </footer>
            </motion.blockquote>
          </AnimatePresence>

          <div className="tests-dots">
            {items.map((_, idx) => (
              <button
                key={idx}
                className={`dot ${idx === i ? 'active' : ''}`}
                onClick={() => setI(idx)}
                aria-label={`Show testimonial ${idx + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
